
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"62","height":"63","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M62 31.87c0-16.844-13.655-30.5-30.5-30.5S1 15.027 1 31.87C1 47.094 12.153 59.712 26.734 62V40.687H18.99V31.87h7.744v-6.72c0-7.644 4.554-11.866 11.52-11.866 3.338 0 6.828.595 6.828.595v7.506h-3.846c-3.789 0-4.97 2.351-4.97 4.763v5.721h8.459l-1.353 8.817h-7.106V62C50.846 59.712 62 47.094 62 31.87z","fill":"#1877F2"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      